module.exports = __webpack_public_path__ + "wales.svg?fae49de9b9650d771e656727dcb56dd1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/wales.svg
// module id = 341
// module chunks = 10